module.exports = __webpack_public_path__ + "static/media/tsbru.c404cdeb.pdf";